import HeaderI18n from './Header.i18n.js';
import {
    mapActions,
    mapGetters,
    mapMutations,
} from 'vuex';

export default {

    components: {},

    props: {},

    computed: {
        ...mapGetters([
            'cart', 'auth', 'priceHiddenMode'
        ]),
        pathIsFleur() {
            if (this.$route.path.includes('fleurs')) {
                return true
            } else {
                return false
            }
        }
    },

    data() {
        return {
            screenWidth: 1200,
            showMobileMenu: false,
            reverse: '',
            vcoConfig: {
                handler: this.handler,
                middleware: this.middleware,
                events: ['dblclick', 'click']
            },
            styleMenu: 'top:550px;',
            recherche: '',
            searchResults: [],
            numberSearchResults: 0,
            afficheResultat: false,
            searchLoader: false,
            debounce: null,
        };
    },

    watch: {
        'showMobileMenu'() {
            let mobMenu = document.getElementById('mob-menu');
            let body = document.querySelector('body');

            if (body !== null) {
                if (mobMenu !== null) {
                    body.style.overflow = 'initial';
                } else {
                    body.style.overflow = 'hidden';
                }
            }
        },

        'recherche'() {
            this.searchLoader = true;
            this.searchResults = [];
            if (this.recherche.length >= 3) {
                clearTimeout(this.debounce);
                this.debounce = setTimeout(() => {
                    this.handleSearchChange();
                }, 600);
            } else {
                this.searchLoader = false;
            }
        }
    },

    methods: {
        ...mapActions({
            getAuth: 'getAuth'
        }),
        ...mapMutations(['setPriceHiddenMode', 'resetFiltres']),

        /**
         * Fonction pour aller vers la page commandes.
         */
        goToCommandes() {
            this.$router.push('/commandes')
        },

        /**
         * Fonction pour activier/désactiver l'affichage des prix.
         */
        toggleHidePrice() {
            const newMode = !this.priceHiddenMode
            this.setPriceHiddenMode(newMode)
        },

        /**
         * Fonction pour retourner à l'accueil.
         */
        goToHome() {
            this.resetFiltres()
            this.$router.push('/')
        }
    },

    mounted() {
        window.addEventListener("resize", () => this.screenWidth = window.innerWidth);
        this.getAuth()
        // Récupération du mode d'affichage
        let priceHiddenMode = localStorage.getItem('priceHidden')
        // Si le cookie n'est pas présent, alors priceHidden est positionné à false puis enregistré en tant que cookie.
        if (priceHiddenMode === null) {
            this.setPriceHiddenMode(false)
        } else {
            // Sinon, priceHidden est positionné à la valeur du cookie.
            priceHiddenMode === 'false' ? this.setPriceHiddenMode(false) : this.setPriceHiddenMode(true)
        }
    },

    i18n: HeaderI18n,

};
